<template>
  <table class="asd-table">
    <thead>
      <tr class="table-heading">
        <th>
          <router-link :to="{name: 'propertyTypeNew'}">
            <button class="asd-btn-confirm">
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </th>
        <th>
          {{ $t('property-type.name') }}
        </th>
        <th>
          {{ $t('property-type.data-type') }}
        </th>
        <th>
          Systémová funkcionalita
        </th>
        <th>
          Automatické předvyplnění do
        </th>
        <th>
          Zobrazit v
        </th>
      </tr>
    </thead>
    <tbody>
      <PropertyTypeRow
        v-for="propertyType in filteredPropertyTypes"
        :key="propertyType.id"
        :propertyTypeId="propertyType.id"
        @setDraggedPropertyType="handleSetDraggedPropertyType"
        @setDroppedPropertyType="handleSetDroppedPropertyType"
      >
      </PropertyTypeRow>
    </tbody>
  </table>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import PropertyTypeRow from 'CORE/components/property-type/row'
import _ from 'lodash'

export default {
    name: 'PropertyTypeTable',
    components: {
        PropertyTypeRow,
    },
    mixins: [
        LangFilters,
    ],
    data() {
        return {
            draggedPropertyType: {},
            droppedPropertyType: {},
            orderChanged: false,
        }
    },
    computed: {
        filteredPropertyTypes() {
            let data = this.$store.getters.propertyTypes
            const orderSorter = pt => {
                return _.toInteger(_.get(pt, 'settings.order', 0))
            }
            data = _.sortBy(data, [orderSorter, 'name'])
            return data
        },
    },
    methods: {
        handleSetDraggedPropertyType(pt) {
            this.draggedPropertyType = pt
        },
        handleSetDroppedPropertyType(pt) {
            this.droppedPropertyType = pt
            this.place(this.droppedPropertyType, this.draggedPropertyType)
        },
        async place(target, dragged) {
            const targetId = _.get(target, 'id')
            const draggedId = _.get(dragged, 'id')
            const index = []
            for (let i = 0; i < this.filteredPropertyTypes.length; i++) {
                const currentId = this.filteredPropertyTypes[i].id
                if (currentId === draggedId) continue
                if (currentId === targetId) index.push(draggedId)
                index.push(currentId)
            }
            for (let i = 0; i < index.length; i++) {
                const currentId = index[i]
                const pt = _.head(_.filter(this.$store.getters.propertyTypes, pt => pt.id === currentId))
                _.set(pt, 'settings.order', i)
            }
            this.orderChanged = true
            await this.$store.dispatch('updateAllPropertyTypes')
            this.flash('Změna pořadí uložena', 'success', {
                timeout: 3000,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
  .table{
    background:#fff;
  }
</style>

